import React, { useMemo } from 'react';
import { useGetIsImpersonator } from '@leagueplatform/auth-utils';
import { useLocation } from '@leagueplatform/routing';
import { impersonationBlockedRoutes } from 'common/app-managed-routes';
import { ImpersonationErrorComponent } from '../impersonation-error/impersonation-error.component';

export const ImpersonationBlocker = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const isImpersonation = useGetIsImpersonator();
  const location = useLocation();

  const isBlockedRoute = useMemo(
    () =>
      impersonationBlockedRoutes.some((route) =>
        location.pathname.startsWith(route),
      ),
    [location.pathname],
  );

  if (!isImpersonation || !isBlockedRoute) return children;

  return <ImpersonationErrorComponent />;
};
